import { RightIcon } from 'foundations-assets';
import HubInfoBox from './HubInfoBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SourceToDestinationBoxes = props => {
  const {
    sourcePortal,
    destinationPortal
  } = props;
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(UIBox, {
      grow: 1,
      children: /*#__PURE__*/_jsx(HubInfoBox, {
        accountName: sourcePortal.accountName,
        portalId: sourcePortal.portalId
      })
    }), /*#__PURE__*/_jsx(View, {
      as: "span",
      marginInline: "200",
      children: /*#__PURE__*/_jsx(RightIcon, {
        size: "900",
        color: "do-not-use-eerie"
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      grow: 1,
      children: /*#__PURE__*/_jsx(HubInfoBox, {
        accountName: destinationPortal.accountName,
        portalId: destinationPortal.portalId
      })
    })]
  });
};
export default SourceToDestinationBoxes;